import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import { createRouter, RouterProvider } from '@tanstack/react-router'

import {
  getContext,
  Provider as TanstackQueryProvider
} from './integrations/tanstack-query/root-provider'
import reportWebVitals from './reportWebVitals.ts'
import './styles.css'
// Import the generated route tree
import { routeTree } from './routeTree.gen'

// Create a new router instance
export const router = createRouter({
  routeTree,
  context: {
    ...getContext()
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 30 * 1000
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Hide initial loading screen setelah React mount
function hideInitialLoading() {
  const loading = document.getElementById('initial-loading')
  if (loading) {
    loading.classList.add('hidden')
  }
}

// Render the app
const rootElement = document.getElementById('app')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <TanstackQueryProvider>
        <RouterProvider router={router} />
      </TanstackQueryProvider>
    </StrictMode>
  )

  // Hide loading screen setelah React mount
  // Gunakan requestAnimationFrame untuk memastikan React sudah render
  requestAnimationFrame(() => {
    setTimeout(hideInitialLoading, 100)
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
